var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pt-2 pl-0 pr-0" },
    [
      _vm.comments
        ? _c(
            "b-row",
            { staticClass: "pl-0 pr-0", attrs: { "align-h": "center" } },
            [
              _c("b-col", { attrs: { cols: _vm.level - 1 } }),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: 12 - _vm.level + 1 } },
                _vm._l(_vm.keys, function(key, index) {
                  return _c(
                    "b-card",
                    {
                      key: index,
                      staticClass: "mb-1",
                      attrs: { "no-body": "" }
                    },
                    [
                      !Array.isArray(_vm.comments.get(key)) || _vm.level === 1
                        ? _c(
                            "b-card-header",
                            {
                              staticClass: "p-1 text-center",
                              attrs: { "header-tag": "header", role: "tab" }
                            },
                            [
                              _c(
                                "b-container",
                                [
                                  _c(
                                    "b-row",
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "text-left",
                                          attrs: { cols: "7" }
                                        },
                                        [_c("h2", [_vm._v(_vm._s(key))])]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c(
                                            "b-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "b-toggle",
                                                  rawName: "v-b-toggle",
                                                  value:
                                                    "accordion" +
                                                    index +
                                                    "-" +
                                                    _vm.myId,
                                                  expression:
                                                    "`accordion${index}-${myId}`"
                                                }
                                              ],
                                              attrs: {
                                                block: "",
                                                href: "#",
                                                variant: "outline-primary",
                                                size: "sm"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Expand/Collapse\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "2" } }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "clickable",
                                            on: {
                                              click: function($event) {
                                                _vm.copy(
                                                  Array.isArray(
                                                    _vm.comments.get(key)
                                                  )
                                                    ? "accordion" +
                                                      index +
                                                      "-" +
                                                      _vm.myId
                                                    : "comment-card-" +
                                                      index +
                                                      "-" +
                                                      _vm.myId
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("font-awesome-icon", {
                                              attrs: {
                                                icon: "copy",
                                                size: "1x"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("small", [_vm._v("Copy")])
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-collapse",
                        {
                          attrs: {
                            id: "accordion" + index + "-" + _vm.myId,
                            accordion: "accordion" + index + "-" + _vm.myId,
                            role: "tabpanel",
                            visible: _vm.level > 1
                          }
                        },
                        [
                          _c(
                            "b-card-body",
                            [
                              Array.isArray(_vm.comments.get(key))
                                ? _c(
                                    "b-container",
                                    { staticClass: "text-left" },
                                    [
                                      _vm.level > 1
                                        ? _c("span", [_vm._v(_vm._s(key))])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        _vm._l(_vm.comments.get(key), function(
                                          comment,
                                          index1
                                        ) {
                                          return _c("li", { key: index1 }, [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  comment.userComment
                                                )
                                              }
                                            })
                                          ])
                                        })
                                      ),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" \n            ")
                                    ]
                                  )
                                : _c("CommentsSection", {
                                    attrs: {
                                      id:
                                        "comment-card-" +
                                        index +
                                        "-" +
                                        _vm.myId,
                                      level: _vm.level + 1,
                                      comments: _vm.comments.get(key)
                                    }
                                  })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                })
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5f3d05e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5f3d05e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentsSection.vue
// module id = null
// module chunks = 